/* @flow */

import * as React from 'react';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './UtilityPortal.style';
import { utilityTopBarElevation } from 'src/shared/app/base/style/token/elevation';

import { portalUtilityId } from 'src/shared/app/base/constant/domConstants';
import Fixed from 'src/shared/app/base/component/fixed/Fixed';
import usePortalRegistrationLength from 'src/shared/app/base/portal/notification/hook/usePortalRegistrationLength';

const useStyles = createUseThemeStyles(styles);

const UtilityPortal = (): React.Node => {
  const ref = React.useRef<HTMLElement | null>(null);
  const [show, setShow]: Object = React.useState<boolean>(false);

  const elementsLength = usePortalRegistrationLength(portalUtilityId);

  React.useEffect(() => {
    setShow(elementsLength > 0);
  }, [elementsLength]);

  const classes = useStyles({ show });

  return (
    <Fixed fullWidth zIndex={utilityTopBarElevation} show={show}>
      <div className={classes.root}>
        <div className={classes.overlay} />
        <div id={portalUtilityId} ref={ref} />
      </div>
    </Fixed>
  );
};

export default React.memo<{}>(UtilityPortal);
